export const BOARD_MAX_CHARS = 280;
export const BOARD_GUEST_MAX_POSTS = 5;
export const BOARD_POST_COOLDOWN_MS = 2 * 60 * 1000;
export const CHECK_IN_POLL_MS = 30_000;

export const CHECK_IN_TAB_FLOOR = "Floor";
export const CHECK_IN_TAB_BOARD = "Shout-outs";

export const BOARD_TAB_FLOOR_HINT = "Rides, food, lost items — tap Shout-outs.";
export const BOARD_INTRO = "Everyone checked in can read this. Meet up offline.";

export const BOARD_SWIPE_DELETE_HINT = "Swipe left or tap your message to delete it.";

export const BOARD_POST_BUTTON = "Post to room";
export const BOARD_POSTING = "Posting…";
export const BOARD_POST_PLACEHOLDER = "Rides, food, lost items…";

export const BOARD_EMPTY = "Nothing here yet. Be the first to post.";
export const BOARD_LOADING = "Loading shout-outs…";
export const BOARD_LOAD_ERROR = "Couldn't load shout-outs. Check your connection.";
export const BOARD_RETRY_BUTTON = "Reload";

export const BOARD_BLOCKED_LIMIT = "You've hit the 5-message limit for tonight.";
export const BOARD_BLOCKED_COOLDOWN = (secs) =>
  `Wait ${secs} second${secs === 1 ? "" : "s"} before posting again.`;
export const BOARD_CHARS_LEFT = (n) => `${n} characters left`;

export const BOARD_LABEL_COMPOSER = "Write to the room";
export const BOARD_ARIA_SECTION = "Shout-out board";

export const BOARD_PIN_LABEL = "Pin for everyone";
export const BOARD_UNPIN_LABEL = "Remove pin";
export const BOARD_DELETE_LABEL = "Delete your message";
